export var EntityTypes;
(function (EntityTypes) {
    EntityTypes["merchant"] = "merchant";
    EntityTypes["employee"] = "employee";
    EntityTypes["anonVisitor"] = "anonymous_visitor";
    EntityTypes["capitalCustomer"] = "capital_customer";
    EntityTypes["developer"] = "developer";
    EntityTypes["person"] = "person";
    EntityTypes["unit"] = "unit";
    EntityTypes["weeblyUser"] = "weebly_user";
    EntityTypes["squareEmployee"] = "square_employee";
    EntityTypes["buyer"] = "buyer";
})(EntityTypes || (EntityTypes = {}));
// for use on cookies or localStorage
export var StoreNames;
(function (StoreNames) {
    StoreNames["userEntityType"] = "cdpUserEntityType";
    StoreNames["userEntityId"] = "cdpUserEntityId";
})(StoreNames || (StoreNames = {}));
// same as store names but only to be used on cookies
export var CookieNames;
(function (CookieNames) {
    CookieNames["avt"] = "_savt";
    CookieNames["enabled"] = "cdpCookiesEnabled";
    CookieNames["trackCookie"] = "track_cookie";
})(CookieNames || (CookieNames = {}));
// same as store names but only to be used on localStorage
export var LSNames;
(function (LSNames) {
    LSNames["userEntityTraits"] = "cdpUserEntityTraits";
    LSNames["groupProps"] = "cdpGroupProps";
    /*
    user traits and group props are potentially
    massive amounts of data, even after encoding.
    We may hit the size limit of the cookie (4kb)
    */
})(LSNames || (LSNames = {}));
// for use on cookies or localStorage in old library
export var LegacyStoreNames;
(function (LegacyStoreNames) {
    LegacyStoreNames["userEntityId"] = "dajs_user_id";
    LegacyStoreNames["userEntityType"] = "da_js_user_type";
    LegacyStoreNames["anonId"] = "dajs_anonymous_id";
    LegacyStoreNames["groupId"] = "dajs_group_id";
})(LegacyStoreNames || (LegacyStoreNames = {}));
// localStorage only keys in old library
export var LegacyLSNames;
(function (LegacyLSNames) {
    LegacyLSNames["groupProps"] = "dajs_group_properties";
    LegacyLSNames["userEntityTraits"] = "dajs_user_traits";
})(LegacyLSNames || (LegacyLSNames = {}));
// Used to keep track of temporarily cached dispatch queue items
export var LsKeysV1;
(function (LsKeysV1) {
    LsKeysV1["items"] = "persisted-queue:v1:items";
    LsKeysV1["seen"] = "persisted-queue:v1:seen";
    LsKeysV1["lockKey"] = "persisted-queue:v1:lock";
})(LsKeysV1 || (LsKeysV1 = {}));
export var Environments;
(function (Environments) {
    Environments["production"] = "production";
    Environments["stage"] = "staging";
    Environments["development"] = "development";
    Environments["localDev"] = "localDev";
})(Environments || (Environments = {}));
export var LogEventsToConsole;
(function (LogEventsToConsole) {
    LogEventsToConsole["on"] = "on";
    LogEventsToConsole["off"] = "off";
    LogEventsToConsole["default"] = "default";
})(LogEventsToConsole || (LogEventsToConsole = {}));
// regex is not a valid enum type, so using a class instead
export class Regex {
}
Regex.uuid = /^[\dA-Fa-f]{8}(?:\b-[\dA-Fa-f]{4}){3}\b-[\dA-Fa-f]{12}$/;
/* Seller Profile tokens: https://java-docs.square.com/roster/tokens
 * We have no guarantee these token formats will stay the same in the future, see link below
 * https://square.slack.com/archives/C03EH7224/p1670872738450729?thread_ts=1670861733.529879&cid=C03EH7224
 */
Regex.merchantToken = /^(merchant:)?[\dA-Z]{13,14}$/;
Regex.unitToken = /^(unit:)?[\dA-Z]{13,14}$/;
// setting min length of 5 as that seems good enough
Regex.employmentToken = /^(employment:)?[\w-]{5,20}$/;
// Events that will be dispatched to the window object
// during parts of the message sending process
export var EmittedEvents;
(function (EmittedEvents) {
    EmittedEvents["BatchCompleted"] = "cdp-batch-completed";
    EmittedEvents["BatchFailed"] = "cdp-batch-failed";
    EmittedEvents["BatchSent"] = "cdp-batch-sent";
    EmittedEvents["DeliveryFailure"] = "cdp-delivery-failure";
    EmittedEvents["DeliverySuccess"] = "cdp-delivery-success";
    EmittedEvents["DoNotRetry"] = "cdp-do-not-retry";
    EmittedEvents["ExcessiveColumns"] = "cdp-excessive-columns";
    EmittedEvents["Invoke"] = "cdp-invoke";
})(EmittedEvents || (EmittedEvents = {}));
export var CdpVersion;
(function (CdpVersion) {
    CdpVersion["V1"] = "v1";
    CdpVersion["V2"] = "v2";
})(CdpVersion || (CdpVersion = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW51bXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY2RwL2VudW1zLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBTixJQUFZLFdBV1g7QUFYRCxXQUFZLFdBQVc7SUFDckIsb0NBQXFCLENBQUE7SUFDckIsb0NBQXFCLENBQUE7SUFDckIsZ0RBQWlDLENBQUE7SUFDakMsbURBQW9DLENBQUE7SUFDcEMsc0NBQXVCLENBQUE7SUFDdkIsZ0NBQWlCLENBQUE7SUFDakIsNEJBQWEsQ0FBQTtJQUNiLHlDQUEwQixDQUFBO0lBQzFCLGlEQUFrQyxDQUFBO0lBQ2xDLDhCQUFlLENBQUE7QUFDakIsQ0FBQyxFQVhXLFdBQVcsS0FBWCxXQUFXLFFBV3RCO0FBRUQscUNBQXFDO0FBQ3JDLE1BQU0sQ0FBTixJQUFZLFVBR1g7QUFIRCxXQUFZLFVBQVU7SUFDcEIsa0RBQW9DLENBQUE7SUFDcEMsOENBQWdDLENBQUE7QUFDbEMsQ0FBQyxFQUhXLFVBQVUsS0FBVixVQUFVLFFBR3JCO0FBRUQscURBQXFEO0FBQ3JELE1BQU0sQ0FBTixJQUFZLFdBSVg7QUFKRCxXQUFZLFdBQVc7SUFDckIsNEJBQWEsQ0FBQTtJQUNiLDRDQUE2QixDQUFBO0lBQzdCLDJDQUE0QixDQUFBO0FBQzlCLENBQUMsRUFKVyxXQUFXLEtBQVgsV0FBVyxRQUl0QjtBQUVELDBEQUEwRDtBQUMxRCxNQUFNLENBQU4sSUFBWSxPQVFYO0FBUkQsV0FBWSxPQUFPO0lBQ2pCLG1EQUF3QyxDQUFBO0lBQ3hDLHVDQUE0QixDQUFBO0lBQzVCOzs7O01BSUU7QUFDSixDQUFDLEVBUlcsT0FBTyxLQUFQLE9BQU8sUUFRbEI7QUFFRCxvREFBb0Q7QUFDcEQsTUFBTSxDQUFOLElBQVksZ0JBS1g7QUFMRCxXQUFZLGdCQUFnQjtJQUMxQixpREFBNkIsQ0FBQTtJQUM3QixzREFBa0MsQ0FBQTtJQUNsQyxnREFBNEIsQ0FBQTtJQUM1Qiw2Q0FBeUIsQ0FBQTtBQUMzQixDQUFDLEVBTFcsZ0JBQWdCLEtBQWhCLGdCQUFnQixRQUszQjtBQUVELHdDQUF3QztBQUN4QyxNQUFNLENBQU4sSUFBWSxhQUdYO0FBSEQsV0FBWSxhQUFhO0lBQ3ZCLHFEQUFvQyxDQUFBO0lBQ3BDLHNEQUFxQyxDQUFBO0FBQ3ZDLENBQUMsRUFIVyxhQUFhLEtBQWIsYUFBYSxRQUd4QjtBQUVELGdFQUFnRTtBQUNoRSxNQUFNLENBQU4sSUFBWSxRQUlYO0FBSkQsV0FBWSxRQUFRO0lBQ2xCLDhDQUFrQyxDQUFBO0lBQ2xDLDRDQUFnQyxDQUFBO0lBQ2hDLCtDQUFtQyxDQUFBO0FBQ3JDLENBQUMsRUFKVyxRQUFRLEtBQVIsUUFBUSxRQUluQjtBQUVELE1BQU0sQ0FBTixJQUFZLFlBS1g7QUFMRCxXQUFZLFlBQVk7SUFDdEIseUNBQXlCLENBQUE7SUFDekIsaUNBQWlCLENBQUE7SUFDakIsMkNBQTJCLENBQUE7SUFDM0IscUNBQXFCLENBQUE7QUFDdkIsQ0FBQyxFQUxXLFlBQVksS0FBWixZQUFZLFFBS3ZCO0FBRUQsTUFBTSxDQUFOLElBQVksa0JBSVg7QUFKRCxXQUFZLGtCQUFrQjtJQUM1QiwrQkFBUyxDQUFBO0lBQ1QsaUNBQVcsQ0FBQTtJQUNYLHlDQUFtQixDQUFBO0FBQ3JCLENBQUMsRUFKVyxrQkFBa0IsS0FBbEIsa0JBQWtCLFFBSTdCO0FBY0QsMkRBQTJEO0FBQzNELE1BQU0sT0FBTyxLQUFLOztBQUNPLFVBQUksR0FDekIseURBQXlELENBQUM7QUFFNUQ7OztHQUdHO0FBQ29CLG1CQUFhLEdBQUcsOEJBQThCLENBQUM7QUFDL0MsZUFBUyxHQUFHLDBCQUEwQixDQUFDO0FBQzlELG9EQUFvRDtBQUM3QixxQkFBZSxHQUFHLDZCQUE2QixDQUFDO0FBR3pFLHNEQUFzRDtBQUN0RCw4Q0FBOEM7QUFDOUMsTUFBTSxDQUFOLElBQVksYUFTWDtBQVRELFdBQVksYUFBYTtJQUN2Qix1REFBc0MsQ0FBQTtJQUN0QyxpREFBZ0MsQ0FBQTtJQUNoQyw2Q0FBNEIsQ0FBQTtJQUM1Qix5REFBd0MsQ0FBQTtJQUN4Qyx5REFBd0MsQ0FBQTtJQUN4QyxnREFBK0IsQ0FBQTtJQUMvQiwyREFBMEMsQ0FBQTtJQUMxQyxzQ0FBcUIsQ0FBQTtBQUN2QixDQUFDLEVBVFcsYUFBYSxLQUFiLGFBQWEsUUFTeEI7QUFFRCxNQUFNLENBQU4sSUFBWSxVQUdYO0FBSEQsV0FBWSxVQUFVO0lBQ3BCLHVCQUFTLENBQUE7SUFDVCx1QkFBUyxDQUFBO0FBQ1gsQ0FBQyxFQUhXLFVBQVUsS0FBVixVQUFVLFFBR3JCIn0=